<template>
    <div class="right-list">
        <div class="right-list-box">
            <div class="right-list-detail"
                 @mouseenter="limouseenter(0)"
                 @mouseleave="limouseleave(0)"
            >
                <div class="right-list-free" @click="toOfferPage()">
                    <img :src="currentHover == 0 ? rightFreeHover : rightFree" alt="">
                    <span :class="currentHover == 0 ? 'spanColor' : ''">免费报价</span>
                </div>
            </div>
            <div class="right-list-detail"
                 @mouseenter="limouseenter(1)"
                 @mouseleave="limouseleave(1)"
            >
                <div class="right-list-free">
                    <img :src="currentHover == 1 ? rightFeedBackHover : rightFeedBack" alt="">
                    <span :class="currentHover == 1 ? 'spanColor' : ''">我要反馈</span>
                </div>

                <div class="feed-box" v-show="currentHover == 1">
                    <div class="feed-box-text">
                        反馈电话 <br>
                        {{ company_mobile }}
                    </div>
                </div>
            </div>
            <div class="right-list-detail"
                 @mouseenter="limouseenter(2)"
                 @mouseleave="limouseleave(2)"
            >
                <div class="right-list-free">
                    <img :src="currentHover == 2 ? rightTelHover : rightTel" alt="">
                    <span :class="currentHover == 2 ? 'spanColor' : ''">电话咨询</span>
                </div>

                <div class="tel-box" v-show="currentHover == 2">
                    <div class="tel-box-text">7*24小时服务</div>
                    <div class="tel-box-telephone">{{ company_mobile }}</div>
                </div>
            </div>
            <div class="right-list-top"
                 @mouseenter="limouseenter(3)"
                 @mouseleave="limouseleave(3)"
                 @click="toTop"
            >
                <img :src="rightTop" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "rightList",
        data() {
            return {
                rightFree: require('@/assets/images/index/rightNav_icon_baojia.png'),
                rightFreeHover: require('@/assets/images/index/rightNav_icon_baojia_pre.png'),
                rightFeedBack: require('@/assets/images/index/rightNav_icon_fankui.png'),
                rightFeedBackHover: require('@/assets/images/index/rightNav_icon_fankui_pre.png'),
                rightTel: require('@/assets/images/index/rightNav_icon_kefu.png'),
                rightTelHover: require('@/assets/images/index/rightNav_icon_kefu_pre.png'),
                rightTop: require('@/assets/images/index/rightNav_icon_top.png'),

                currentHover: -1,
                company_mobile: '',
            }
        },
        mounted(){
            this.getHomeWebSet();
        },
        methods: {
            getHomeWebSet() {
                this.$axios.get('/HomeWebSet', {}).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        this.address = res.data.address;
                        this.app_qr_code = res.data.app_qr_code;
                        this.company_mobile = res.data.company_mobile;
                        this.copyright = res.data.copyright;
                        this.email = res.data.email;
                        this.logo = res.data.logo;
                    } else {
                        // layer.msg('系统错误，请刷新', {icon: 2});
                        this.$message.error('系统错误，请刷新');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            limouseenter(num) {
                this.currentHover = num;
            },
            limouseleave(num) {
                this.currentHover = -1;
            },
            toOfferPage(){
                this.$router.push({path: '/offer'});
            },
            toTop() {
                let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
                let step = distance / 30; //每步的距离
                (function jump() {
                    if (distance > 0) {
                        distance -= step;
                        window.scrollTo(0, distance);
                        setTimeout(jump, 10);
                    }
                })();
            }
        }
    }
</script>

<style scoped>
    .right-list {
        width: 64px;
        height: 398px;
        border: 1px solid #E5E5E5;
        border-radius: 2px;
        z-index: 20;
        position: fixed;
        top: 35%;
        right: 0;
        background: #fff;
    }

    .right-list-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .right-list-detail {
        width: 64px;
        height: 108px;
        border-bottom: 1px solid #E5E5E5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .feed-box {
        width: 206px;
        height: 107px;
        position: absolute;
        top: 0;
        left: -207px;
        border-top: 1px solid #E5E5E5;
        border-left: 1px solid #E5E5E5;
        border-bottom: 1px solid #E5E5E5;
        border-radius: 2px;
        background: #fff;
    }

    .feed-box-text {
        width: 130px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 32px;
        margin: 20px 0 0 30px;
    }

    .right-list-free {
        width: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
    }

    .right-list-free img {
        width: 30px;
        height: 30px;
    }

    .right-list-free span {
        width: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-top: 10px;
    }

    .right-list-free .spanColor {
        color: #FA592A;
    }

    .tel-box {
        width: 206px;
        height: 107px;
        position: absolute;
        top: 0;
        left: -207px;
        border-top: 1px solid #E5E5E5;
        border-left: 1px solid #E5E5E5;
        border-bottom: 1px solid #E5E5E5;
        border-radius: 2px;
        background: #fff;
    }

    .tel-box-text {
        margin: 20px 0 0 30px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
    }

    .tel-box-telephone {
        margin: 6px 0 0 30px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FA592A;
        line-height: 24px;
    }

    .right-list-top {
        width: 64px;
        height: 66px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .right-list-top img {
        width: 30px;
        height: 30px;
    }

</style>



// WEBPACK FOOTER //
// src/components/rightList.vue